import { createStore, applyMiddleware } from 'redux';
import { createLogger } from 'redux-logger';
import { createBrowserHistory } from 'history';
import { connectRouter, routerMiddleware } from 'connected-react-router';

import thunk from 'redux-thunk';
import {
    persistStore,
    persistCombineReducers,
    persistReducer
} from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import auth from './reducer/auth/reducer';
import app from './reducer/app/reducer';
import calendar from './reducer/calendar/reducer';
import clipboard from './reducer/clipboard/reducer';
import feed from './reducer/feed/reducer';
import library from './reducer/library/reducer';
import nav from './reducer/nav/reducer';
import uiTree from './reducer/uiTree/reducer';
import summary from './reducer/summary/reducer';
import analytics from './reducer/analytics/reducer';
import user from './reducer/user/reducer';
import calendarCollapse from './reducer/calendarCollapse/reducer';
import maintenance from './reducer/maintenance/reducer';
import notifications from '../v5/notifications/state/notificationsReducer';
import features from '../v5/features/state/featuresReducer';
import notificationSettings from '../v5/notificationSettings/state/notificationSettingsReducer';
import messagingSummaryDrawer from '../v5/messaging/state/reducer';
import reactionsList from '../v5/messaging/state/reactionsListReducer';
import reactionsLookup from '../v5/messaging/state/reactionsLookupReducer';

import APP_CONFIG from '../api/config';

// store persistence
const storeConfig = {
    key: 'trainheroic',
    storage,
    whitelist: ['auth', 'router', 'app.loggedInUser', 'calendarCollapse']
};

// app routing
const history = createBrowserHistory();

const clipboardPersistConfig = {
    key: 'clipboard',
    storage,
    whitelist: ['copiedSessions']
};

// reducer & store creation
const reducers = persistCombineReducers(storeConfig, {
    analytics,
    auth,
    app,
    calendar,
    clipboard: persistReducer(clipboardPersistConfig, clipboard),
    feed,
    library,
    nav,
    summary,
    user,
    uiTree,
    calendarCollapse,
    maintenance,
    notifications,
    features,
    notificationSettings,
    messagingSummaryDrawer,
    reactionsList,
    reactionsLookup,
    router: connectRouter(history)
});

const getMiddleWare = () => {
    let middleware = [routerMiddleware(history), thunk];
    if (APP_CONFIG.REDUX_LOGGER_ENABLED) {
        middleware.push(createLogger());
    }

    return applyMiddleware(...middleware);
};

let store = createStore(reducers, getMiddleWare());

const persister = persistStore(store);

export const getPersister = () => persister;
export const getStore = () => store;
export const getState = () => store.getState();
export const getHistory = () => history;
export const setMockedStore = mockedStore => {
    store = mockedStore;
};
